import { useEffect, useRef } from 'react';

type useTimeoutArgs = {
  timeoutCallback: () => void;
  timeInMilliseconds: number;
};

const useTimeout = (args: useTimeoutArgs) => {
  const { timeoutCallback, timeInMilliseconds } = args;

  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const setTimeoutRef = () =>
    (timeoutRef.current = setTimeout(timeoutCallback, timeInMilliseconds));

  const clearTimeoutRef = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  };

  useEffect(() => {
    return clearTimeoutRef;
  }, []);

  return {
    setTimeoutRef,
    clearTimeoutRef,
  };
};

export { useTimeout };
